import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, Location } from '@angular/common';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
import { NgSelectModule } from '@ng-select/ng-select';

interface AccountData {
  reference: string;
  lastname: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}
@Component({
  selector: 'app-form-add-orders',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    NgSelectModule,
  ],
  templateUrl: './form-add-orders.component.html',
  styleUrl: './form-add-orders.component.css',
})
export class FormAddOrdersComponent {

  @Output() emitSubmit = new EventEmitter<string>();
  @Output() backButtonClick2 = new EventEmitter<boolean>();
  @Input() clientData?: any;
  @Input() ladata: any = [];
  @Input() client_reference?: any;
  @Input() tab?: any;
  @Input() openedFromClients = false;
  @Input() activeFormTab?: any;
  title = '';
  form: FormGroup = new FormGroup({});
  updatesTabs: any[] = [];
  draft = false;
  order_reference: string = '';
  stage?: any;
  newStage: string = '';
  role: any;

  account_type = this.authStateService.getAccountType();

  back = '';
  next_ok = '';
  next_ko = '';

  agentData: AccountData[] = [];
  dealershipData: AccountData[] = [];
  organizationData: AccountData[] = [];
  supplierData: AccountData[] = [];
  @Input() formAddOrderOpened2?: boolean;
  @Input() clientName: string = '';
  @Input() formAddOrderOpened?: string;

  clientTitle: any;

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private localStorageService: LocalStorageService,
    private authStateService: AuthStateService,
    private orderService: OrdersService,
    private location: Location,
    private titleService: Title,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.form = this.fb.group({
      broker_id: ['', Validators.required],
      broker_agent: ['', Validators.required],
      broker_agent_id: ['', Validators.required],
      broker_reference: ['', Validators.required],
      notes: ['', Validators.required],
      stage: ['draft', Validators.required],
      supplier_id: ['', Validators.required],
      supplier_agent: ['', Validators.required],
      supplier_agent_id: ['', Validators.required],
      supplier_reference: ['', Validators.required],
      vendor_id: ['', Validators.required],
      vendor_quote_reference: ['', Validators.required],
      vendor_agent_id: ['', Validators.required],
      vendor_reference: ['', Validators.required],
    });
  }


  ngOnInit(): void {


  }
  ngAfterViewInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (this.formAddOrderOpened2) {

        this.titleService.setTitle(`Cliente ${this.clientName} - DBM`);
      } else {
        this.titleService.setTitle(`Clientes - DBM`);
      }
      if (changes['ladata']) {

        this.role = this.authStateService.getRole();
        this.agentData = this.ladata.agentData;
        this.vendorData = this.ladata.vendorData;
        this.brokerData = this.ladata.brokerData;
        if (this.brokerData.length === 1) {
          // Selecciona automáticamente la única opción
          this.form.patchValue({ broker_id: this.brokerData[0].reference });
        }
        this.supplierData = this.ladata.supplierData;
        if (this.account_type == 'broker' && !this.draft) {
        }
      }
    }
  }

  setVariables() {
    this.back = this.orderData?.back || '';
    this.next_ok = this.orderData?.next_ok;
    this.next_ko = this.orderData?.next_ko;
    this.stage = this.orderData?.stage;
    this.draft = this.orderData ? true : false;
    this.order_reference = this.orderData?.reference;
    const allStageKeys: string[] = [
      ...(this.orderData?.stage ? [this.orderData.stage] : []),
      ...((this.orderData?.stages || []).filter((s: string) => s !== this.orderData?.stage)),
    ];
    this.stages = allStageKeys.map((key: string) => ({ key }));
  }
  document_buttons_chico = false;


  emitBackButtonClick() {
    this.backButtonClick2.emit(true);
    this.document_buttons_chico = false;
    this.resetForm();
  }

  @Input() orderData?: any;

  vendorData: AccountData[] = [];
  brokerData: AccountData[] = [];
  stages: { key: string }[] = [];

  changeStage(event: any) {
    this.newStage = event;
  }

  onSubmitOrderFast(stage: string) {
    this.emitSubmit.emit(stage);
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  onSubmit() {
    let formData = { ...this.form.value };
    formData.client_id = this.client_reference;
    formData.stage = 'draft';
    this.alertService.loading('swal_messages.please_wait_add_order');
    this.orderService.addData(formData).subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_order', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            const nuevaURL = this.location.path();


            if (this.openedFromClients) {
              const updatedURL = `/orders/drafts/${data.data.reference}`;
              this.location.go(updatedURL);
              this.router.navigate([updatedURL]);


            }
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  emitAddOrder() {
    this.addOrder.emit(true);
  }
  @Output() addOrder = new EventEmitter<boolean>();

  resetForm(): void {
    this.form.reset({
      broker_id: '',
      broker_agent: '',
      broker_agent_id: '',
      broker_reference: '',
      notes: '',
      stage: '',
      supplier_id: '',
      supplier_agent: '',
      supplier_agent_id: '',
      supplier_reference: '',
      vendor_id: '',
      vendor_quote_reference: '',
      vendor_agent_id: '',
      vendor_reference: '',
    });
  }
}
